module.exports = __webpack_public_path__ + "partial-fix.svg";